import { Modal, ProgressBar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useAppUpdate } from '../hooks/useAppUpdate'
import styles from './UpdateModal.module.css'

const UpdateModal: React.FC = () => {
    const { t } = useTranslation('common')
    const { state, progress } = useAppUpdate()

    const show = state === 'updating' || state === 'ready' || state === 'reloading'

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            className={styles.modal}
            contentClassName={styles.modalContent}
            aria-labelledby="update-modal-title"
        >
            <Modal.Body className={styles.modalBody}>
                <p id="update-modal-title" className={styles.title}>{t('update.title')}</p>
                <ProgressBar
                    now={progress}
                    className={styles.progressBar}
                    animated={state === 'updating'}
                />
            </Modal.Body>
        </Modal>
    )
}

export default UpdateModal
